module.exports = __webpack_public_path__ + "img/Manage-Sales-Reps.19a854fc.png";